require('./contractEasyLoanStep1.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @components
const ContractLoanSliders = require('../../contractLoanSliders/contractLoanSliders');
const ContractEasyLoanStepOneWaffer = require('../contractEasyLoanStep1Waffer/contractEasyLoanStep1Waffer');
const ContractLoanDueInformation = require('../../contractLoanDueInformation/contractLoanDueInformation');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
//@constants
const {
    PURPOSE_BUY_VEHICLE,
    PURPOSE_FIX_HOUSE,
    PURPOSE_HOME_ELEMENTS,
    PURPOSE_STUDIES,
    PURPOSE_HEALTH,
    PURPOSE_TRAVEL,
    PURPOSE_OTHER
} = require('../../../../loansConstants/index').contractEasyLoan;
//@constants
const {
    NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES,
    EVIDENCE_EASY_LOAN
} = require('constants/flagBasedFeatures');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@utilities
const { getFormattedString } = require('utilities/currencyHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');


class ContractEasyLoanStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.handlePurposeSelectChange = this.handlePurposeSelectChange.bind(this);
        this.handlePreContractInformationDownload = this.handlePreContractInformationDownload.bind(this);
    }

    componentDidMount() {
        this.props.getInstallment();
        this.props.requestMinInstallmentQuantity();
    }

      componentDidUpdate() {
        const {immContractEasyLoan, immFlagBasedFeatures, setInitApiFlag, onAgreeReset, toggleINEAgreeCheckbox, officePrintReset, resetMailSent}=this.props
        if(immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN)
        || immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && !immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN)){
        if((immContractEasyLoan.get('selectedPurpose') !== immContractEasyLoan.get('firstSelectedPurpose')) || 
        (immContractEasyLoan.get('selectedAmount') !== immContractEasyLoan.get('firstSelectedAmount'))|| 
        (immContractEasyLoan.get('selectedTerm')!==immContractEasyLoan.get('firstSelectedTerm'))) {  
            setInitApiFlag(true,true, false, false)
            if (immContractEasyLoan.get('agreeIneCheckbox')){
                onAgreeReset();
            }
            if(isPrintOfficeMode() && immContractEasyLoan.get('officePrintStepThree')){
                officePrintReset();
            }
            __CONTACT_CENTER__ && !isPrintOfficeMode() && resetMailSent(false)
        }
        else {
            setInitApiFlag(false,false,true, false)
                if(!immContractEasyLoan.get('agreeIneCheckbox')){
                   toggleINEAgreeCheckbox()
                }
                if(isPrintOfficeMode() && !immContractEasyLoan.get('officePrintStepThree')){
                    officePrintReset(true);
                }
                __CONTACT_CENTER__ && !isPrintOfficeMode() && resetMailSent(true)
        }
        }
      }

    getPurposeTranslation(constant) {
        const purposeTranslationsSubkey = {
            PURPOSE_BUY_VEHICLE: 'purposeBuyVehicle',
            PURPOSE_FIX_HOUSE: 'purposeFixHouse',
            PURPOSE_HOME_ELEMENTS: 'purposeHomeElements',
            PURPOSE_STUDIES: 'purposeStudies',
            PURPOSE_HEALTH: 'purposeHealth',
            PURPOSE_TRAVEL: 'purposeTravel',
            PURPOSE_OTHER: 'purposeOther'
        };

        const translationSubkey = purposeTranslationsSubkey[constant];
        const wholeTransKey = 'contractEasyLoanStepOne-' + translationSubkey;

        return formatText(wholeTransKey);
    }

    // *** Section builers ***

    buildHeader() {
        const immContractEasyLoan = this.props.immContractEasyLoan;
        const immProfile = this.props.immProfile;
        const maxAmountToHireObj = {
            amount: immContractEasyLoan.get('maxAmount'),
            decimalsLength: 0,
            currency: immContractEasyLoan.get('currency')
        };

        const clientSurname = immProfile.getIn(['apellidoUno', 'apellido' ]);
        const maxAmountToHire = getFormattedString(maxAmountToHireObj);
        const maximumAvailableTerms = immContractEasyLoan.get('maxTerm');
        const tae = immContractEasyLoan.get('tae');
        const tin = immContractEasyLoan.get('tin');

        const injectedStringsTwo = [maxAmountToHire, maximumAvailableTerms];
        const injectedStringsThree = [clientSurname, maxAmountToHire, tin, tin, tae];
       
        const isContactCenterOrOffice = __CONTACT_CENTER__ || isPrintOfficeMode();

        return (
            <header className="contract-easy-loan-step-one__header">
                <div className="contract-easy-loan-step-one__title">
                    <FormattedText value="contractEasyLoanStepOne-title" />
                </div>
                <div className="contract-easy-loan-step-one__informative-text">
                    <FormattedText value="contractEasyLoanStepOne-messageOne" />
                    
                </div>
                {isContactCenterOrOffice ? (
                    <>
                        <br/>
                        <BlockInfo>
                            <FormattedText value="contractEasyLoanStepOne-messageThree" injectedStrings={injectedStringsThree} />
                        </BlockInfo>
                    </>
                ) : null}
                <div className="contract-easy-loan-step-one__secondary-message">
                    <FormattedText value="contractEasyLoanStepOne-messageTwo" injectedStrings={injectedStringsTwo} />
                </div>
            </header>
        );

    }

    buildPurposeSelect() {
        const selectedPurpose = this.props.immContractEasyLoan.get('selectedPurpose');
        const errorState = this.props.immContractEasyLoan.get('showPurposeError');
        const errorMessage = formatText('contractEasyLoanStepOne-purposeError');
        const purposeConstants = [
            PURPOSE_BUY_VEHICLE,
            PURPOSE_FIX_HOUSE,
            PURPOSE_HOME_ELEMENTS,
            PURPOSE_STUDIES,
            PURPOSE_HEALTH,
            PURPOSE_TRAVEL,
            PURPOSE_OTHER
        ];

        const options = purposeConstants.map(value => {
            return {
                value,
                label: this.getPurposeTranslation(value)
            };
        });

        //(nicolas.olmos): selected value is only used to generate PDF.
        return (
            <div className="contract-easy-loan-step-one__purpose-select">
                <div className="contract-easy-loan-step-one__purpose-select-title">
                    <FormattedText value="contractEasyLoanStepOne-purpose" />
                </div>
                <OKSelect
                    errorState={errorState}
                    errorMessage={errorMessage}
                    options={options}
                    value={selectedPurpose}
                    onChange={this.handlePurposeSelectChange}
                />
            </div>
        );
    }

    buildSliderSection() {
        const { immContractEasyLoan, setLoanTerm, setLoanAmount,
            getInstallment, requestMinInstallmentQuantity, showTooltip } = this.props;
        const maxAmountError = immContractEasyLoan.get('maxAmountError');

        return (
            <ContractLoanSliders
                amountMaxInstallment
                showSectionTitle
                amountTitle="contractEasyLoanStepOne-firstSliderTitle"
                termTitle="contractEasyLoanStepOne-secondSliderTitle"
                getInstallment={getInstallment}
                getMinInstallment={requestMinInstallmentQuantity}
                immContractLoan={immContractEasyLoan}
                setLoanAmount={setLoanAmount}
                setLoanTerm={setLoanTerm}
                showTooltip={showTooltip}
                isMaxAmountError={maxAmountError}
            />
        );
    }

    //  *** Handlers ***

    handlePreContractInformationDownload() {
        this.props.downloadPreContractDocument();
    }

    handlePurposeSelectChange(purpose) {
        this.props.setPurpose({ purpose: purpose.value });
    }

    render() {
        const { immContractEasyLoan } = this.props;
        const header = this.buildHeader();
        const sliderSection = this.buildSliderSection();
        const purposeSelect = this.buildPurposeSelect();

        return (
            <section className="contract-easy-loan-step-one">
                {header}
                {sliderSection}
                {purposeSelect}
                <ContractEasyLoanStepOneWaffer immContractEasyLoan={immContractEasyLoan} />
                <div className="contract-easy-loan-step-one__see-info text-right">
                    <OKButton
                        onClick={this.handlePreContractInformationDownload}
                        modifier="link-complementary"
                    >
                        <FormattedText value="contractEasyLoanStepOne-seeNormalizedEuropeanInformation" />
                    </OKButton>
                </div>
                <ContractLoanDueInformation title="gdprEasyLoan-title" message="gdprEasyLoan-message" />
            </section>
        );
    }
}

ContractEasyLoanStep1.propTypes = {
    downloadPreContractDocument: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    showTooltip: PropTypes.bool.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    setInitApiFlag: PropTypes.func,
    toggleINEAgreeCheckbox: PropTypes.func,
    onAgreeReset: PropTypes.func,
    officePrintReset: PropTypes.func,
    resetMailSent: PropTypes.func
};

module.exports = ContractEasyLoanStep1;
